import React, { useEffect, useState, useContext } from "react";
import { CiBookmark, CiLocationOn } from "react-icons/ci";
import { NavLink, useNavigate } from "react-router-dom";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../store/stateFunctions";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import "./jobs.css";
import { IoIosBookmark } from "react-icons/io";
import configContext from "../../context/configContext/configContext";

const Jobs = () => {
  document.title = "Jobs";
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [bookmarkedJobs, setBookmarkedJobs] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const navigate = useNavigate();

  // const data = [
  //   {
  //     id: 1,
  //     logo: "/images/logo1.png",
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Vendor Relations Manager",
  //   },
  //   {
  //     id: 2,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior UX/UI Designer",
  //   },
  //   {
  //     id: 3,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior Marketer",
  //   },
  //   {
  //     id: 4,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Field Sales Executive",
  //   },
  //   {
  //     id: 5,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Telecaller",
  //   },
  //   {
  //     id: 6,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior Marketer",
  //   },
  //   {
  //     id: 7,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Field Sales Executive",
  //   },
  //   {
  //     id: 8,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Telecaller",
  //   },
  // ];

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/job/getallind_job", {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        toast.error(error);
        setProcessing(false);
        setProgress(100);
      });
  };

  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/job/getalljobs", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        toast.error(error);
        setProcessing(false);
        setProgress(100);
      });
  };

  const addBookmark = (itemId) => {
    if (!user) {
      navigate("/loginstudent");
      toast.dark("Please login to add job to your bookmark");
      return;
    }

    server
      .post(
        `/job/addbookmark/${itemId}`,
        {},
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Added to Bookmark successfully:", response.data.message);
        toast.success(response.data.message);
        // setBookmarkedJobs((prevBookmarkedJobs) =>
        //   prevBookmarkedJobs.includes(itemId)
        //     ? prevBookmarkedJobs.filter((id) => id !== itemId)
        //     : [...prevBookmarkedJobs, itemId]
        // );
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error);
      });
  };

  const addYuvaBookmark = (itemId) => {
    if (!user) {
      navigate("/loginstudent");
      toast.dark("Please login to add job to your bookmark");
      return;
    }

    server
      .post(
        `/job/admbookmark/${itemId}`,
        {},
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Added to Bookmark successfully:", response.data.message);
        toast.success(response.data.message);
        // setBookmarkedJobs((prevBookmarkedJobs) =>
        //   prevBookmarkedJobs.includes(itemId)
        //     ? prevBookmarkedJobs.filter((id) => id !== itemId)
        //     : [...prevBookmarkedJobs, itemId]
        // );
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error);
      });
  };

  const SearchData = (searchValue) => {
    server
      .get(`/job/searchalljob?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        toast.error(error);
      });
  };

  // search filter wise
  const FilterModewiseData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/job/searchjobmode?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else {
          toast.error(error.response.data.error);
        }
      });
  };

  return (
    <>
      <div
        className="container-xl text-decoration-none "
        style={{ marginTop: "1rem" }}
      >
        <div className="row py-2">
          <div className="col-md-6 my-1">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-6 my-1">
            <select
              className="form-control"
              onChange={(e) => FilterModewiseData(e)}
            >
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
          </div>
        </div>
        <div className="row ">
          {data &&
            data?.map((item) => {
              return (
                <>
                  <div className="job-container col-md-4 my-2" key={item.id}>
                    <div className="jobs">
                      <div className="job p-2">
                        <div className="row" style={{ height: "9rem" }}>
                          <div className="col-md-8">
                            <h5 className="job-title">{item.position}</h5>
                            <p>{item.company_name}</p>
                          </div>
                          <div className="col-md-2 mt-5 text-end">
                            <img
                              src={item.image}
                              width={100}
                              // className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>

                        <p>
                          <span className="fw-bold"> Status : &nbsp;</span>
                          <span className="badge bg-warning text-dark p-2">
                            {item.status}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">Job Openings : &nbsp;</span>
                          <span className="">{item.noofposition}</span>
                        </p>
                        <table>
                          <tr>
                            <td>
                              <FaLocationDot className="fs-4 me-2 text-danger " />
                            </td>
                            <td>
                              <p className="my-2">{item.address}</p>
                            </td>
                          </tr>
                        </table>
                        <div className="details text-center">
                          <div className="row p-1">
                            <div className="col m-2 btn btn-outline-info text-dark ">
                              {item.job_mode} Mode
                            </div>

                            <div className="col m-2 btn btn-outline-info text-dark ">
                              {item.experience} yrs
                            </div>
                          </div>
                          <NavLink
                            to={`/jobs/${item.id}`}
                            className="banner text-white ms-2 bg-light btn w-75 "
                          >
                            More Details
                          </NavLink>
                        </div>
                        <span className="open-positions">
                          <span
                            className="open-positions"
                            key={item.id}
                            onClick={() => addYuvaBookmark(item.id, false)}
                          >
                            {/* {bookmarkedJobs.includes(item.id) ? (
                            <IoIosBookmark />
                          ) : (
                            <CiBookmark />
                          )} */}
                            <IoIosBookmark />
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}

          {industryData &&
            industryData?.map((item) => {
              console.log("Industry Job Item:", item);
              return (
                <>
                  {item.status === "Post" ? (
                    <div className="job-container col-md-4 my-2" key={item.id}>
                      <div className="jobs">
                        <div className="job p-2">
                          <div className="row" style={{ height: "9rem" }}>
                            <div className="col-md-8">
                              <h5 className="job-title">{item.position}</h5>
                              <p>{item.company_name}</p>
                            </div>
                            <div className="col-md-2 mt-5 text-end">
                              <img src={item.image} width={100} alt="" />
                            </div>
                          </div>
                          <p>
                            <span className="fw-bold"> Status : &nbsp;</span>
                            <span className="badge bg-warning text-dark p-2">
                              {item.status1}
                            </span>
                          </p>
                          <p>
                            <span className="fw-bold">
                              Job Openings : &nbsp;
                            </span>
                            <span className="">{item.noofposition}</span>
                          </p>
                          <table>
                            <tr>
                              <td>
                                <FaLocationDot className="fs-4 me-2 text-danger " />
                              </td>
                              <td>
                                <p className="my-2">{item.address}</p>
                              </td>
                            </tr>
                          </table>
                          <div className="details text-center">
                            <div className="row p-1">
                              <div className="col m-2 btn btn-outline-info text-dark ">
                                {item.job_mode} Mode
                              </div>

                              <div className="col m-2 btn btn-outline-info text-dark ">
                                {item.experience} yrs
                              </div>
                            </div>
                            <NavLink
                              to={`/industryjobs/${item.id}`}
                              className="banner text-white ms-2 bg-light btn w-75 "
                            >
                              More Details
                            </NavLink>
                          </div>
                          <span className="open-positions">
                            <span
                              className="open-positions"
                              key={item.id}
                              onClick={() => addBookmark(item.id, false)}
                            >
                              {/* {bookmarkedJobs.includes(item.id) ? (
                              <IoIosBookmark />
                            ) : (
                              <CiBookmark />
                            )} */}
                              <IoIosBookmark />
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Jobs;
